import React from "react";

export const FormSubmitContext = React.createContext<
(event: React.SyntheticEvent<any, Event>) => void
>(() => undefined);